import {Observable}  from 'rxjs';
import {filter, map} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const createRewindTapStream = (uiEvents$: Observable<IUiEventsStreamPayload>): Observable<void> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.REWIND_TAP),
            map(() => void 0)
        );

export default createRewindTapStream;